// accordion js

$(function () {
  $(".js-accordion-button").click(function () {
    $(this).next(".accordion__content").slideToggle();
    $(this).toggleClass("is-open");
  });
});

// loader

document.addEventListener("DOMContentLoaded", function () {
  // Check if the current page is exactly the homepage (https://maccam.la/)
  if (
    window.location.href === "https://maccam.la/" ||
    window.location.pathname === "/"
  ) {
    // Show loader for 2-3 seconds, then fade out
    setTimeout(function () {
      const loader = document.getElementById("loader");
      loader.style.transition = "opacity 1s ease"; // Apply fade-out transition
      loader.style.opacity = "0"; // Fade out

      // After fade-out is complete (1 second), hide the loader
      setTimeout(function () {
        loader.style.display = "none";
      }, 2000); // 1 second fade-out duration
    }, 10000); // 2 seconds delay before fade-out
  } else {
    // Immediately hide the loader on other pages
    const loader = document.getElementById("loader");
    if (loader) {
      loader.style.display = "none";
    }
  }
});

// tab collection

document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll(".tabs li");
  var tabContents = document.querySelectorAll(".tab-content");

  function hideAllTabs() {
    tabContents.forEach(function (content) {
      content.classList.remove("active");
    });
    tabs.forEach(function (tab) {
      tab.classList.remove("active");
    });
  }

  function showTab(tabId) {
    document.getElementById(tabId).classList.add("active");
  }

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      hideAllTabs();
      tab.classList.add("active");
      showTab(tab.getAttribute("data-tab"));
    });
  });

  // Show the first tab by default
  if (tabs.length > 0) {
    tabs[0].click();
  }
});

$(document).ready(function () {
  var block_size = $(".tab-content").attr("block-size");
  for (var i = 1; i <= block_size; i++) {
    $(".tab-index-grid-" + i).each(function () {
      var length_a = $(this).find("a").length;

      $(this).addClass("active_size_" + length_a);
    });
  }
});

$(document).ready(function () {
  $(".text_2_link").on("click", function (e) {
    // Prevent default behavior
    e.preventDefault();

    // Smooth scroll to the target section
    $("html, body").animate(
      {
        scrollTop: $("#footer-block__newsletter_social").offset().top,
      },
      500
    ); // Adjust the duration (1000ms) for the smooth scrolling effect as needed
  });
});
// Slick Slider
$(document).ready(function () {
  $(".shop-banner-blocks").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
$(document).ready(function () {
  $(".product-type-container").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrow: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

$(document).ready(function () {
  // Initialize the slider with Slick
  $(".slider-wrapper").slick({
    autoplay: false,
    dots: false,
    speed: 400,
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 7,
    pauseOnHover: true, // Pause when hovering on the slider
    draggable: true, // Allow dragging
    swipe: true, // Enable swipe for mobile
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 7,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

// =============================================================

// Pair with It Section

// =============================================================

$(document).ready(function () {
  function initializeSlick() {
    // Check if the screen is mobile (for example, less than or equal to 768px)
    if (window.matchMedia("(max-width: 768px)").matches) {
      // Initialize slick only if it hasn't been initialized yet
      if (!$(".paired-products").hasClass("slick-initialized")) {
        $(".paired-products").slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1.3,
          arrows: false,
          initialSlide: 0,
        });
      }
    } else {
      // Destroy slick if it is initialized (on larger screens)
      if ($(".paired-products").hasClass("slick-initialized")) {
        $(".variable-widthpaired-products").slick("unslick");
      }
    }
  }

  // Call the function to initialize slick on page load
  initializeSlick();

  // Re-initialize slick on window resize
  $(window).resize(function () {
    initializeSlick();
  });
  // Function to format price with currency
  function formatMoneyWithCurrency(amount) {
    let formattedAmount = (amount / 100).toFixed(2); // Ensure two decimal places
    return `$${formattedAmount}`;
  }

  // Function to update the total price based on checked checkboxes
  function updateTotalPrice() {
    let totalPrice = 0;

    // Loop through each checked checkbox
    $(".pair_product_checkbox:checked").each(function () {
      const productItem = $(this).closest(".paired-product-item");
      const productPrice = parseFloat(productItem.attr("data-price")); // Get price as a number (in cents)
      totalPrice += productPrice; // Add to total price
    });

    // Format the total price with currency and update the total price display
    $("#totalPrice").text(formatMoneyWithCurrency(totalPrice));
  }

  // Function to update the button text with the number of selected checkboxes
  function updateButtonText() {
    let selectedCount = $(".pair_product_checkbox:checked").length;
    $("#addToCartButton").text(`Add all ${selectedCount} to Cart`);
  }

  function updatePairedProductsClass() {
    const divCount = $(".paired-products .paired-product-item").length; // Count the number of paired-product-item divs

    // Remove any previously added classes that match the pattern
    $(".paired-products").removeClass("two_div three_div four_div");

    // Add the appropriate class based on the number of divs
    if (divCount === 2) {
      $(".paired-products").addClass("two_div");
    } else if (divCount === 3) {
      $(".paired-products").addClass("three_div");
    } else if (divCount >= 4) {
      $(".paired-products").addClass("four_div");
    }
  }

  // Function to save the checked state of checkboxes to local storage
  function saveCheckboxState() {
    let checkboxStates = {};
    $(".pair_product_checkbox").each(function () {
      checkboxStates[$(this).attr("id")] = $(this).is(":checked");
    });
    localStorage.setItem("checkboxStates", JSON.stringify(checkboxStates));
  }

  // Function to restore the checked state of checkboxes from local storage
  function restoreCheckboxState() {
    let checkboxStates = localStorage.getItem("checkboxStates");
    if (checkboxStates) {
      checkboxStates = JSON.parse(checkboxStates);
      $(".pair_product_checkbox").each(function () {
        const checkboxId = $(this).attr("id");
        if (checkboxStates.hasOwnProperty(checkboxId)) {
          $(this).prop("checked", checkboxStates[checkboxId]);
        }
      });
    }
  }

  // Function to add selected products to the cart
  function addToCart(selectedProducts) {
    if (selectedProducts.length > 0) {
      $.post("/cart/add.js", { items: selectedProducts })
        .done(function (response) {
          console.log("Products added to cart:", response);
          console.log("Products added to cart successfully!");

          // Redirect to the cart page after products are added
          window.location.href = "/cart";
        })
        .fail(function (error) {
          console.error("Error adding products to cart:", error);
          console.log(
            "Error: " +
              (error.responseJSON
                ? JSON.stringify(error.responseJSON)
                : "There was an error adding products to the cart. Please try again.")
          );
        });
    } else {
      console.log("Please select at least one product to add to the cart.");
    }
  }

  // Event listener for the "Add to Cart" button
  $("#addToCartButton").on("click", function () {
    let selectedProducts = [];
    $(".pair_product_checkbox:checked").each(function () {
      const productItem = $(this).closest(".paired-product-item");
      const productId = productItem.attr("data-id"); // Get the product variant ID from data attribute
      selectedProducts.push({ id: productId, quantity: 1 }); // Prepare the product object
    });

    // Add selected products to cart
    addToCart(selectedProducts);
  });

  // Update total price and button text when checkbox is checked/unchecked
  $(".pair_product_checkbox").on("change", function () {
    updateTotalPrice();
    updateButtonText();
    saveCheckboxState(); // Save the checkbox state whenever it is changed
  });

  // Restore the checkbox states and update the total price and button text on page load
  restoreCheckboxState();
  updateTotalPrice();
  updateButtonText(); // Update the button text with the number of initially checked products
  updatePairedProductsClass();
});
